import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UIState {
  isMobileMenuOpen: boolean
  isContactModalOpen: boolean
  activeSection: string
  isLoading: boolean
  theme: 'dark' | 'light'
  scrollPosition: number
}

const initialState: UIState = {
  isMobileMenuOpen: false,
  isContactModalOpen: false,
  activeSection: 'home',
  isLoading: false,
  theme: 'dark',
  scrollPosition: 0,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleMobileMenu: (state) => {
      state.isMobileMenuOpen = !state.isMobileMenuOpen
    },
    closeMobileMenu: (state) => {
      state.isMobileMenuOpen = false
    },
    toggleContactModal: (state) => {
      state.isContactModalOpen = !state.isContactModalOpen
    },
    openContactModal: (state) => {
      state.isContactModalOpen = true
    },
    closeContactModal: (state) => {
      state.isContactModalOpen = false
    },
    setActiveSection: (state, action: PayloadAction<string>) => {
      state.activeSection = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setTheme: (state, action: PayloadAction<'dark' | 'light'>) => {
      state.theme = action.payload
    },
    setScrollPosition: (state, action: PayloadAction<number>) => {
      state.scrollPosition = action.payload
    },
  },
})

export const {
  toggleMobileMenu,
  closeMobileMenu,
  toggleContactModal,
  openContactModal,
  closeContactModal,
  setActiveSection,
  setLoading,
  setTheme,
  setScrollPosition,
} = uiSlice.actions

export default uiSlice.reducer